import { takeLatest, put } from 'redux-saga/effects';
import _get from 'lodash/get';

import api from '../../../utils/apiConfig';
import UrlConfig from '../../../utils/urlHelper';
import { FETCH_PASSBOOK_DATA } from './constants';
import { setTxnDetails } from './actions';

interface Url {
  fetchPassbookData: Function;
  downloadTransactions: Function;
}

const urlHelper: Url = UrlConfig;

function* fetchTransactions(action: any) {
  const { data } = action;
  try {
    const response = yield api.get(urlHelper.fetchPassbookData(data.query));
    const responseData = response.data;
    if (responseData.success) {
      const response = _get(responseData, 'data', {});
      yield put(setTxnDetails({ ...response, reset: data.reset }));
    } else {
      yield put(setTxnDetails({ reset: true }));
    }
  } catch (e) {
    yield put(setTxnDetails({ reset: true }));
  }
}

function* mySaga() {
  yield takeLatest(FETCH_PASSBOOK_DATA, fetchTransactions);
}

export default mySaga;
